import { Command, Editor } from "ckeditor5";
import { MediaType } from "../types";

export const getMediaModel = (mediaType: MediaType) => `${mediaType}Block`;

export default class InsertMediaCommand extends Command {
  private mediaType: MediaType;

  constructor(editor: Editor, mediaType: MediaType) {
    super(editor);
    this.mediaType = mediaType;
  }

  execute(options: { src: string }): void {
    const { editor, mediaType } = this;

    editor.model.change((writer) => {
      const element = writer.createElement(getMediaModel(mediaType), {
        src: options.src,
      });

      editor.model.insertContent(element, editor.model.document.selection);
    });
  }

  refresh(): void {
    this.isEnabled = true;
  }
}
